import { Button, Form, Input, message } from 'antd';
import React from 'react';
import { ReactComponent as EmailIcon } from "../../../assets/svgs/icons/email-icon.svg";
import { UserManagerContainer } from '../UserManager.style';
import { Store } from '../../../store/Store';
import { useSnapshot } from 'valtio';
import { resendVerificationCode, signUpConfirmCode } from '../userManagementUtils';
import { useNavigate } from 'react-router-dom';
import ConfirmCode from '../signup/ConfirmCode';

const VerificationCode = () => {
    const [isConfirmCode, setIsConfirmCode] = React.useState(false);
    const [userMail, setUserMail] = React.useState('');
    const navigate = useNavigate();
    const handleLoginClick = () => {
        navigate('/login');
    };

    const handleVerification = (values: any) => {
        if (!values.email) {
            message.warning("Please enter email and password!")
            return;
        }
        if (!values.email.includes("@")) {
            message.warning("Please enter a valid email address.", 2);
            return;
        }
        Store.isInitialized = false
        resendVerificationCode(values.email).then((result) => {
            message.success("Verification code sent successfully. Please check your email for the confirmation code.");
            setUserMail(values.email);
            setIsConfirmCode(true);
        }).catch((err) => {
            if (err.code === "NotAuthorizedException") {
                message.error("User is already confirmed. Please login to continue.");
                navigate('/login');
                return;
            }
            message.error(err?.message || "Failed to send verification code.");
        }).finally(() => {
            Store.isInitialized = true
        });
    }

    return (
        <UserManagerContainer>
            <div className='login__block'>
                <div className="login_inner_box">
                    <div className='login_inner_top_box'>
                        <h2>LiDAR Atlas</h2>
                    </div>
                    <div className='login_inner_middle_box'>
                        <div className='login_middle_title_box'>
                            <h2>Re-Verification</h2>
                            <p>Please fill all the mandatory fields to continue</p>
                        </div>
                        <div className='login__form__block'>
                            {
                                !isConfirmCode ? (
                                    <Form
                                        name="normal_login"
                                        className="login-form"
                                        initialValues={{ remember: false }}
                                        onFinish={handleVerification}
                                    >
                                        <Form.Item
                                            name="email"
                                            rules={[{ required: true, message: 'Please Enter Email!' }]}
                                            className='form_input_field'
                                        >
                                            <Input size="large" prefix={<EmailIcon key="EmailIcon" />} placeholder="Email*" autoComplete="email" />
                                        </Form.Item>
                                        
                                        <Form.Item>
                                            <Button htmlType="submit" size='large' className="user_control_btn">
                                                Verify Email
                                            </Button>
                                        </Form.Item>
                                    </Form>
                                ) :
                                    (
                                        <ConfirmCode userMail={userMail} setIsConfirmCode={setIsConfirmCode}/>
                                    )
                            }
                        </div>
                    </div>
                    <div className='login_inner_bottom_box'>
                        <span onClick={handleLoginClick}>Already have an account? Sign In</span>
                    </div>
                </div>
            </div>
        </UserManagerContainer>
    );
}

export default VerificationCode;
